'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var computeRepeatScopeMeta = function computeRepeatScopeMeta(scopeArray) {
  var scope;
  var length = scopeArray.length;
  for (var i = 0; i < length; i++) {
    scope = scopeArray[i];
    scope.$index = i;
    scope.$first = i === 0;
    scope.$last = i === length - 1;
    scope.$middle = !(scope.$first || scope.$last);
  }
};
ngModule.factory("treeTableDefaultConfig", function () {
  return {
    // config
    idAttribute: "id",
    labelAttribute: "id",
    childrenAttribute: "children",
    // images path
    spacerCrossClass: "spacer-cross",
    spacerCornerClass: "spacer-corner",
    spacerLineClass: "spacer-line",
    spacerNoneClass: "spacer-none",
    // events
    onRowClick: function onRowClick(model, scope, row) {},
    // templates
    rowTemplate: '<tr tree-table-row></tr>',
    mainCellTemplate: '<td></td>',
    mainCellContentTemplate: '<span>{{model[config.labelAttribute]}}</span>',
    spacerTemplate: '<tree-table-spacer></tree-table-spacer>'
  };
});
ngModule.directive("treeTable", function ($compile, $interpolate) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: '<div class="tree-table" tabindex="0">' + '   <div class="tree-head">' + '       <table class="tree-head-table">' + '           <colgroup></colgroup>' + '           <thead></thead>' + '       </table>' + '   </div>' + '   <div class="tree-body">' + '       <table class="tree-body-table">' + '           <colgroup></colgroup>' + '           <tbody></tbody>' + '       </table>' + '   </div>' + '</div>',
    controller: function controller($scope, $element, treeTableDefaultConfig) {
      var ctrl = this,
        initialized = false,
        linkers = {};
      var ui = {
        table: $element,
        headDiv: $element.find(".tree-head"),
        headTable: $element.find(".tree-head table"),
        headColgroup: $element.find(".tree-head table colgroup"),
        contentDiv: $element.find(".tree-body"),
        contentTable: $element.find(".tree-body table"),
        contentColgroup: $element.find(".tree-body table colgroup"),
        contentBody: $element.find(".tree-body table tbody")
      };
      var compileLinkers = function compileLinkers() {
        linkers.row = $compile(config.rowTemplate);
        linkers.mainCell = $compile(config.mainCellTemplate);
        linkers.mainCellContent = $compile(config.mainCellContentTemplate);
        linkers.spacer = $compile(config.spacerTemplate);
      };
      var bindEvents = function bindEvents() {
        // row click
        $element.delegate(".tree-body table tbody tr", "click", function (event) {
          var row = $(event.currentTarget);
          var rowScope = row.scope();
          var rowModel = rowScope.model;
          $scope.$apply(function () {
            config.onRowClick(rowModel, rowScope, row);
          });
        });
      };
      var config = null;
      ctrl.initialize = function (_config) {
        config = _.extend({}, angular.copy(treeTableDefaultConfig), _config);
        $scope.config = config;
        compileLinkers();
        config.$linkers = linkers;
        config.$ui = ui;
        bindEvents();
        initialized = true;
      };
      ctrl.getConfig = function () {
        return config;
      };
      var dataSource = null;
      ctrl.setDataSource = function (_dataSource) {
        dataSource = _dataSource;
        startCollectionWatch();
      };
      var childCollection = [];
      var startCollectionWatch = function startCollectionWatch() {
        var watchDataSource = function watchDataSource() {
          return dataSource;
        };
        $scope.$watchCollection(watchDataSource, function (newCollection, oldCollection) {
          var addedChildren = newCollection === oldCollection ? newCollection : _.difference(newCollection, oldCollection);
          _.each(addedChildren, function (model) {
            ctrl.createRootRow(model);
          });
          var removedChildren = newCollection === oldCollection ? [] : _.difference(oldCollection, newCollection);
          _.each(removedChildren, function (model) {
            ctrl.removeRootRow(model);
          });
          ctrl.recomputeChildrenScopesMeta();
        });
      };
      ctrl.recomputeChildrenScopesMeta = function () {
        computeRepeatScopeMeta(_.map(childCollection, function (row) {
          return row.scope;
        }));
      };
      $scope.$on("recompute-tree-indexes", function (event) {
        event.stopPropagation();
        ctrl.recomputeChildrenScopesMeta();
      });
      ctrl.createRootRow = function (model) {
        var rowScope = $scope.$new();
        _.extend(rowScope, {
          model: model,
          root: true,
          depth: 0,
          parent: null
        });
        linkers.row(rowScope, function (row) {
          ui.contentBody.append(row);
          childCollection.push({
            model: model,
            scope: rowScope,
            element: row
          });
        });
      };
      ctrl.removeRootRow = function (model) {
        var child = _.find(childCollection, {
          model: model
        });
        child.scope.$destroy();
        child.element.remove();
      };
    },
    link: function link($scope, $el, $attrs, ctrl) {
      $attrs.$observe("tableConfig", function (tableConfigAttrName) {
        var tableConfig = $scope.$parent.$eval(tableConfigAttrName);
        ctrl.initialize(tableConfig);
        var source = tableConfig.source;
        $scope.$watch(source, function (source) {
          if (source == null) {
            return;
          }
          ctrl.setDataSource(source);
        });
      });
    }
  };
});
ngModule.directive("treeTableRow", function () {
  return {
    restrict: "A",
    scope: true,
    require: ["^treeTable", "treeTableRow"],
    controller: function controller($scope, $element) {
      var ctrl = this;
      var childCollection = $scope.children = [];
      var findLastNode = function findLastNode() {
        if (!$scope.children.length) {
          return $element;
        }
        var children = $scope.children;
        var lastChild;
        do {
          lastChild = children[children.length - 1];
          children = lastChild.element.scope().children;
        } while (children.length);
        return lastChild.element;
      };
      ctrl.createChildRow = function (model) {
        var childScope = $scope.$new();
        _.extend(childScope, {
          model: model,
          root: false,
          depth: $scope.depth + 1,
          parent: $scope
        });
        $scope.config.$linkers.row(childScope, function (row) {
          var lastNode = findLastNode();
          row.insertAfter(lastNode);
          childCollection.push({
            model: model,
            scope: childScope,
            element: row
          });
        });
      };
      ctrl.removeChildRow = function (model) {
        var child = _.find(childCollection, {
          model: model
        });
        if (child == null) {
          return;
        }
        child.scope.$destroy();
        child.element.remove();
        var childIdx = _.indexOf(childCollection, child);
        if (childIdx > -1) {
          childCollection.splice(childIdx, 1);
        }
      };
      ctrl.recomputeSpacers = function () {
        $scope.$emit("recompute-tree-indexes");
        $scope.$broadcast("recompute-spacer");
      };
      $scope.$on("recompute-tree-indexes", function () {
        ctrl.recomputeChildrenScopesMeta();
      });
      ctrl.recomputeChildrenScopesMeta = function () {
        // console.log('recompute children scopes meta')
        computeRepeatScopeMeta(_.map(childCollection, function (row) {
          return row.scope;
        }));
      };
      ctrl.getScope = function () {
        return $scope;
      };
      $scope.$on("$destroy", function () {
        _.each(_objectSpread({}, childCollection), function (child) {
          ctrl.removeChildRow(child.model);
        });
      });
    },
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0];
      var rowCtrl = controllers[1];
      var config = tableCtrl.getConfig();
      $el.attr("row-depth", $scope.depth);
      $el.addClass("depth-" + $scope.depth);
      var mainCell;
      config.$linkers.mainCell($scope, function (_mainCell) {
        mainCell = _mainCell.appendTo($el);
      });
      for (var i = 0; i < $scope.depth; i++) {
        var spacerScope = $scope.$new();
        spacerScope.$index = i;
        config.$linkers.spacer(spacerScope, function (spacer) {
          spacer.appendTo(mainCell);
        });
      }
      config.$linkers.mainCellContent($scope, function (mainCellContent) {
        mainCellContent.appendTo(mainCell);
      });
      $scope.$watchCollection("model." + config.childrenAttribute, function (newChildren, oldChildren) {
        var removedChildren = newChildren === oldChildren ? [] : _.difference(oldChildren, newChildren);
        _.each(removedChildren, function (child) {
          rowCtrl.removeChildRow(child);
        });
        var addedChildren = newChildren === oldChildren ? newChildren : _.difference(newChildren, oldChildren);
        _.each(addedChildren, function (child) {
          rowCtrl.createChildRow(child);
        });
        rowCtrl.recomputeSpacers();
      });
    }
  };
});
ngModule.directive("treeTableSpacer", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["^treeTable", "^treeTableRow"],
    template: '<div class="spacer"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0];
      var rowCtrl = controllers[1];
      var config = tableCtrl.getConfig();
      var depth = $scope.depth;
      var index = $scope.$index;
      var upwardCount = depth - index - 1;
      var isLastSpacer = upwardCount === 0;
      var spacerRowScope = rowCtrl.getScope();
      for (var i = 0; i < upwardCount; i++) {
        spacerRowScope = spacerRowScope.parent;
      }
      $scope.$on("recompute-spacer", function () {
        recomputeSpacer();
      });
      var lastClass = null;
      var recomputeSpacer = function recomputeSpacer() {
        var hasNextSibling = !spacerRowScope.$last;
        var newClass = null;
        if (isLastSpacer) {
          if (hasNextSibling) {
            newClass = config.spacerCrossClass;
          } else {
            newClass = config.spacerCornerClass;
          }
        } else {
          if (hasNextSibling) {
            newClass = config.spacerLineClass;
          } else {
            newClass = config.spacerNoneClass;
          }
        }
        $el.removeClass(lastClass).addClass(newClass);
        lastClass = newClass;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/treeTable.js
// module id = 3027
// module chunks = 13